module.exports = __webpack_public_path__ + "img/del.04afc803.svg";